export const  TrendData = [
    {
        name:"Minions",
        shares:97,
    },
    {
        name:"Avangers",
        shares:80.5,
    },
    {
        name:"ZainkeepsCode",
        shares:75.5,
    },
    {
        name:"ReactJS",
        shares:72,
    },
    {
        name:"Elon Musk",
        shares:97,
    }, 
]